import { axiosInstance } from '@configs/axios/axiosInstance';

import type { CheckUserEmailRequest } from './checkUserEmail.types';

/**
 * Check if a user email already exists in an organization.
 * Endpoint: HEAD /users?email=...
 *
 * `organizationId` is sent as the X-Organization-ID request header.
 *
 * @returns true if x-total-count > 0, false otherwise
 */
export async function checkUserEmail(
  params: CheckUserEmailRequest,
  signal?: AbortSignal
): Promise<boolean> {
  const { email, organizationId } = params;

  try {
    const response = await axiosInstance.head('/users', {
      params: { email },
      headers: { 'X-Organization-ID': organizationId },
      signal,
    });

    const totalCount = Number(response.headers['x-total-count']) || 0;
    return totalCount > 0;
  } catch (error: unknown) {
    if (signal?.aborted) {
      throw error;
    }

    const isNotFound =
      error !== null &&
      typeof error === 'object' &&
      'response' in error &&
      (error as { response?: { status?: number } }).response?.status === 404;

    if (isNotFound) {
      return false;
    }

    throw error;
  }
}
